import React, { useState } from "react";
import closeIcon from "../../../../../assets/icon/chatClose.svg";
import ArrowRight from "../../../../../assets/icon/arrow-right-purple.svg";
import doubleArrow from "../../../../../assets/icon/double-arrow-down.svg";
import productDetailsImg from "../../../../../assets/reports/product-details.svg";

import { Col, Row } from "reactstrap";
import ReactStrapTable from "components/reactStrapTable";
import { useLocation } from "react-router-dom";

const ListOverLay = ({ data }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openListOverlay, setOpenListOverLay] = useState(false);
  const [showImg, setShowImg] = useState(false);

  const columnData = [
    {
      dataField: "period",
      text: "Period",
      show: true,
      sort: true,
    },
    {
      dataField: "totalcharges",
      text: "Total Charges",
      show: true,
      sort: true,
      width: 150,
    },
    {
      dataField: "insurancepayments",
      text: "Insurance Payments",
      show: true,
      sort: true,
      width: 200,
    },
    {
      dataField: "patientcopays",
      text: "Patient Copays",
      show: true,
      sort: true,
      width: 150,
    },
    {
      dataField: "otherpayments",
      text: "Other Payments",
      show: true,
      sort: true,
      width: 150,
    },
    {
      dataField: "adjustments",
      text: "Adjustments",
      show: true,
      sort: true,
      width: 150,
    },
    {
      dataField: "totalpayments",
      text: "Total Payments",
      show: true,
      sort: true,
      width: 150,
    },
  ];

  const rowData = [
    {
      period: "Aug-24",
      id: 1,
      totalcharges: "$ 150.00",
      insurancepayments: "$ 120.00",
      patientcopays: "$ 20.00",
      otherpayments: "$ 10.00",
      adjustments: "$ -",
      totalpayments: "$ 150.00",
    },
    {
      period: "Sep-24",
      id: 2,
      totalcharges: "$ 200.00",
      insurancepayments: "$ 160.00",
      patientcopays: "$ 30.00",
      otherpayments: "$ 10.00",
      adjustments: "$ -",
      totalpayments: "$ 200.00",
    },
    {
      period: "Oct-24",
      id: 3,
      totalcharges: "$ 175.00",
      insurancepayments: "$ 140.00",
      patientcopays: "$ 25.00",
      otherpayments: "$ 10.00",
      adjustments: "$ -",
      totalpayments: "$ 175.00",
    },
    {
      period: "Nov-24",
      id: 3,
      totalcharges: "$ 100.00",
      insurancepayments: "$ 80.00",
      patientcopays: "$ 15.00",
      otherpayments: "$ 5.00",
      adjustments: "$ -",
      totalpayments: "$ 100.00",
    },
    {
      period: "Dec-24",
      id: 3,
      totalcharges: "$ 125.00",
      insurancepayments: "$ 100.00",
      patientcopays: "$ 15.00",
      otherpayments: "$ 10.00",
      adjustments: "$ -",
      totalpayments: "$ 125.00",
    },
    {
      period: "Total",
      id: 4,
      totalcharges: "$ 750.00",
      insurancepayments: "$ 600.00",
      patientcopays: "$ 105.00",
      otherpayments: "$ 45.00",
      adjustments: "$ -",
      totalpayments: "$ 750.00",
    },
  ];

  return (
    <div
      style={{ width: "81vw", height: "auto" }}
      className="table-card
      scroll-table
      position-relative
      border-0
      rounded
      bg-white"
    >
      <div className="border mb-2 p-6 bg-white bx-shadow">
        <Row>
          <Col md={12}>
            <h3
              className="patient-demo"
              onClick={() => setOpenListOverLay(!openListOverlay)}
            >
              Report Details
              <span className="cursor-pointer">
                {openListOverlay ? (
                  <img
                    src={doubleArrow}
                    style={{
                      transform: "rotate(180deg)",
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                  />
                ) : (
                  <img
                    src={doubleArrow}
                    style={{ transition: "opacity 0.3s ease" }}
                  />
                )}
              </span>
            </h3>
            <Col sm={12} className="d-flex justify-content-start gap-5">
              <div>
                <span class="pdetails">Patient: </span>
                <span className="patient-details">Doe, John</span>
              </div>

              <div>
                <span className="pdetails purple-border-left ">Period: </span>
                <span className="patient-details">
                  Last Year (1/1/2024 - 12/31/2024)
                </span>
              </div>

              <div>
                <span className="pdetails purple-border-left ">Grouping: </span>{" "}
                <span className="patient-details">By Month</span>
              </div>
              <div>
                <span className="pdetails purple-border-left ">
                  Show Balance:{" "}
                </span>
                <span className="patient-details">No</span>
              </div>
            </Col>
          </Col>
        </Row>
      </div>
      <div className="reports-container">
        <div className="report-product-details">
          <div>
            Product Details{" "}
            <span
              className="cursor-pointer"
              style={{marginLeft:"12px"}}
              onClick={() => setShowImg(!showImg)}
            >
              {showImg ? (
                <img
                  src={doubleArrow}
                  style={{
                    transform: "rotate(180deg)",
                    transition: "opacity 0.3s ease, transform 0.3s ease",
                  }}
                />
              ) : (
                <img
                  src={doubleArrow}
                  style={{ transition: "opacity 0.3s ease" }}
                />
              )}
            </span>
          </div>
        </div>
        {showImg ? (
          <div className="report-product-img">
            <img
              style={{ width: "150vw" }}
              src={productDetailsImg}
              alt="not available"
            />
          </div>
        ) : (
          <></>
        )}
      </div>
      <ReactStrapTable
        data={rowData}
        columns={columnData}
        setOpenModal={setOpenModal}
        openModal={openModal}
        purpleRow={[5]}
      />
    </div>
  );
};

export default ListOverLay;
